import { GITHUB_TYPE } from "./Types";

export const initialGithubState = {
  loading: false,
  githubCode: [],
};

export function githubReducer(state, action) {
  switch (action.type) {
    case GITHUB_TYPE.GITHUBCODES:
      return { ...state, githubCode: action.payload };
    case GITHUB_TYPE.IS_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}
